import React from 'react'
import * as styles from './priceCard.module.css'
import Svg1 from '../../images/svg/check.svg'

const PriceCard = (props) => {
  return (
    <div className={styles.priceCard}>
      <span>{props.price.name}</span>
      <span>{props.price.price} &#8381;</span>
      <span>{props.price.desc}</span>
      <ul>
        {props.price.features.map((el) => {
          return (
            <li key={el}>
              <Svg1 />
              <p>{el}</p>
            </li>
          )
        })}
      </ul>
      <button onClick={props.onClick}>Заказать веб-сайт</button>
    </div>
  )
}

export default PriceCard
